import { SET_PARTNER_DATA } from "app/actionTypes";

export const setPartnerData = data => {
	return {
		type: SET_PARTNER_DATA,
		data,
	};
};
